import statuses from '@/store/statuses';
import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {
    languagesList: { // Paginated list for crud
      data: [],
      status: statuses.EMPTY,
    },
    languagesClassifier: { // Global listing for dropdowns 
      data: [],
      status: statuses.EMPTY,
    },
  };
};

const Languages = {
  namespaced: true,
  state: defaultState,
  getters: {
    languagesList: (state) => state.languagesList,
    activeLanguages: (state) => state.languagesClassifier.data.filter((e) => e.is_active),
  },
  mutations,
  actions,
};

export { Languages, defaultState };
